import axios from 'axios';

export const verifyToken = async (token: string) => {
  try {
    const response = await axios.get(`${process.env.NEXT_PUBLIC_API_URL}users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      success: true,
      status: response.status,
      message: response.data.message || 'Token is valid',
      payload: response.data.payload || null,
    };
  } catch (err: any) {
    return {
      success: false,
      status: err.response?.status || 500,
      message: err.response?.data?.message || 'An error occurred during token verification',
      payload: null,
    };
  }
};
